import script from "./VistaPreviewInforme.vue?vue&type=script&setup=true&lang=ts"
export * from "./VistaPreviewInforme.vue?vue&type=script&setup=true&lang=ts"

import "./VistaPreviewInforme.vue?vue&type=style&index=0&id=fd14c854&scoped=true&lang=css"
import "./VistaPreviewInforme.vue?vue&type=style&index=1&id=fd14c854&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd14c854"]])

export default __exports__